export default __webpack_public_path__ + "static/AppMoneyWalkie9-d19fff6ab3944a1cf60344f84ad351d0.png";